import { jsx as _jsx } from "react/jsx-runtime";
import { TopicV2, TopicV2List as BaseTopicV2List } from "@sprout/client-components/dist/TopicV2";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import naturalCompare from "natural-compare";
import { useMemo } from "react";
import styled from "styled-components";
const TopicV2List = styled(BaseTopicV2List)`
  margin-top: 0;

  /* & ~ .ProfilePageUserPostsDividerText { */
  /*   display: block; */
  /* } */
`;
const ProfilePageUserTopics = (props)=>{
    const currentUser = useCurrentUser();
    const currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
    const { user  } = props;
    const topics = useMemo(()=>{
        return user.topics.nodes/**
         * NOTE: https://sprout.io/todo/42226
         * We are hiding `public: false` topics when viewing personal topics
         */ .filter((topic)=>{
            const { rootTopicOrSelf  } = topic;
            const { owner  } = rootTopicOrSelf || {};
            if ((owner === null || owner === void 0 ? void 0 : owner.id) === currentUserId && !(rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.public)) return false;
            return true;
        }).sort((a, b)=>{
            return naturalCompare(a.title || "", b.title || "");
        });
    }, [
        currentUserId,
        user.topics.nodes
    ]);
    if (topics.length === 0) return null;
    return /*#__PURE__*/ _jsx(TopicV2List, {
        id: "ProfilePageUserTopics",
        className: "ProfilePageUserTopics",
        children: topics.map((topic)=>{
            return /*#__PURE__*/ _jsx(TopicV2, {
                topic: topic
            }, topic.nodeId);
        })
    });
};
export default ProfilePageUserTopics;
